import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';
import { DrugNotificationService, DrugNotificationType } from 'src/app/services/drug-notification.service';
import { PatientService } from 'src/app/services/patient.service';
import { PrescriptionUiService } from 'src/app/services/prescription-ui.service';
import { TypeManagerService } from 'src/app/services/type-manager.service';

@Component({
  selector: 'app-action-icons',
  templateUrl: './action-icons.component.html',
  styleUrls: ['./action-icons.component.scss']
})
export class ActionIconsComponent implements OnInit {

  constructor(public patient: PatientService, private typeManager: TypeManagerService,
              private dialog: MatDialog, public prescriptionui: PrescriptionUiService,
              private notification: DrugNotificationService) { }

  ngOnInit(): void {
    this.prescriptionui.loadStored();
    this.notification.getEmitter().subscribe(notification => {
      if (notification.type === DrugNotificationType.add) {
        this.prescriptionui.addItem(notification.item as CNPrescriptionEntry);
      }
    });
  }

  openContact() {
    console.log('openContact');
  }

  openPrescription() {
    console.log('openPrescription');
    if (this.typeManager.typeMap('PrescriptionDialogComponent')) {
      const componentFactory = this.typeManager.typeMap('PrescriptionDialogComponent');
      const dialogRef = this.dialog.open(componentFactory, {
          data: {
            service: this.prescriptionui
          }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });
    }

  }
}
